var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9245 8.16684L16.7675 2.32371C17.2996 1.79153 17.2996 0.931321 16.7675 0.399137C16.2353 -0.133046 15.3751 -0.133046 14.8429 0.399137L8.99992 6.24227L3.15691 0.399137C2.62474 -0.133046 1.76455 -0.133046 1.23238 0.399137C0.700209 0.931321 0.700209 1.79153 1.23238 2.32371L7.07539 8.16684L1.23238 14.01C0.700209 14.5421 0.700209 15.4024 1.23238 15.9345C1.49779 16.1999 1.84622 16.3333 2.19465 16.3333C2.54308 16.3333 2.89151 16.1999 3.15691 15.9345L8.99992 10.0914L14.8429 15.9345C15.1083 16.1999 15.4568 16.3333 15.8052 16.3333C16.1536 16.3333 16.5021 16.1999 16.7675 15.9345C17.2996 15.4024 17.2996 14.5421 16.7675 14.01L10.9245 8.16684Z",
    fill: "#7B819B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.50abfa6b8d98075f74ad1bb68ea58f05.svg";
export { ForwardRef as ReactComponent };